import {
  CustomerGroupFormValues,
  CustomerGroupItem,
  CustomerGroupListParams,
  CustomerGroupListResponse,
  GetCustomerGroupResponse,
} from "utils/api/client/types"

class CustomerGroup {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  async list(
    vendorId: string,
    queryParams?: CustomerGroupListParams,
    headers?: Record<string, string>
  ): Promise<CustomerGroupListResponse> {
    return (this.client as any).fetch(`/vendor/${vendorId}/groups`, {
      headers,
      query: queryParams,
    })
  }

  async create(
    vendorId: string,
    body: CustomerGroupFormValues,
    headers?: Record<string, string>
  ): Promise<CustomerGroupItem> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/groups`, {
        method: "POST",
        headers,
        body,
      })
    })()
  }

  async edit(
    vendorId: string,
    groupId: string,
    body: CustomerGroupFormValues,
    headers?: Record<string, string>
  ) {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/groups/${groupId}`,
        {
          method: "PUT",
          headers,
          body,
        }
      )
    })()
  }

  async getById(
    vendorId: string,
    id: string,
    headers?: Record<string, string>
  ): Promise<GetCustomerGroupResponse> {
    return (this.client as any).fetch(`/vendor/${vendorId}/groups/${id}`, {
      headers,
    })
  }

  async removeCustomerFromGroup(
    vendorId: string,
    groupId: string,
    customerId: string,
    headers?: Record<string, string>
  ) {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/groups/remove-customer`,
        {
          method: "POST",
          headers,
          body: {
            group_ids: [groupId],
            customer_ids: [customerId],
          },
        }
      )
    })()
  }

  async addCustomerToGroup(
    vendorId: string,
    groupId: string,
    customerIds: string[],
    headers?: Record<string, string>
  ) {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/groups/add-customer`,
        {
          method: "POST",
          headers,
          body: {
            group_ids: [groupId],
            customer_ids: customerIds,
          },
        }
      )
    })()
  }
}

export { CustomerGroup }
